/** Single source of truth for the desktop odds-table geometry. Consumed by the
 *  real table (VirtualizedPropTable / SelectedPlayersTable) AND by
 *  OddsViewSkeleton, whose CLS fix depends on the skeleton matching the loaded
 *  layout pixel-for-pixel — change a value here and both surfaces move
 *  together. */
export const PRIMARY_COL_WIDTH = 320;
export const BEST_LINE_COL_WIDTH = 176;
export const SPORTSBOOK_COL_WIDTH = 148;
/** Row pitch used as the virtualizer estimate and the skeleton row height. */
export const TABLE_ROW_HEIGHT = 64;
